import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PermissionAssigneeTargetLinkQueryCriteriaClass extends BaseCriteriaModel {
  perm_dfn_guid?: Optional<string> = Optional.empty();
  assignee_type?: Optional<string> = Optional.empty();
  assignee_hdr_table?: Optional<string> = Optional.empty();
  assignee_hdr_guid?: Optional<string> = Optional.empty();
  assignee_line_guid?: Optional<string> = Optional.empty();
  assignee_line_table?: Optional<string> = Optional.empty();
  target_type?: Optional<string> = Optional.empty();
  target_hdr_table?: Optional<string> = Optional.empty();
  target_hdr_guid?: Optional<string> = Optional.empty();
  target_line_guid?: Optional<string> = Optional.empty();
  target_line_table?: Optional<string> = Optional.empty();
  tenant_hdr_guid?: Optional<string> = Optional.empty();
  applet_hdr_guid?: Optional<string> = Optional.empty();

}

export class PermissionAssigneeTargetLinkCriteriaModelQuery {
  query = '';

  constructor(permissionAssigneeTargetLinkCriteriaModel: PermissionAssigneeTargetLinkQueryCriteriaClass) {

    if (!permissionAssigneeTargetLinkCriteriaModel) {
      return;
    }

    this.query += permissionAssigneeTargetLinkCriteriaModel.perm_dfn_guid.filter(x => x !== '').map(x => '&perm_dfn_guid=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.assignee_type.filter(x => x !== '').map(x => '&assignee_type=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.assignee_hdr_table.filter(x => x !== '').map(x => '&assignee_hdr_table=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.assignee_hdr_guid.filter(x => x !== '').map(x => '&assignee_hdr_guid=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.assignee_line_guid.filter(x => x !== '').map(x => '&assignee_line_guid=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.assignee_line_table.filter(x => x !== '').map(x => '&assignee_line_table=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.target_type.filter(x => x !== '').map(x => '&target_type=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.target_hdr_table.filter(x => x !== '').map(x => '&target_hdr_table=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.target_hdr_guid.filter(x => x !== '').map(x => '&target_hdr_guid=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.target_line_guid.filter(x => x !== '').map(x => '&target_line_guid=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.target_line_table.filter(x => x !== '').map(x => '&target_line_table=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.tenant_hdr_guid.filter(x => x !== '').map(x => '&tenant_hdr_guid=' + x).orElse('');
    this.query += permissionAssigneeTargetLinkCriteriaModel.applet_hdr_guid.filter(x => x !== '').map(x => '&applet_hdr_guid=' + x).orElse('');

    this.query += '&status=' + permissionAssigneeTargetLinkCriteriaModel.status;
    this.query += '&orderBy=' + permissionAssigneeTargetLinkCriteriaModel.orderBy;
    this.query += '&order=' + permissionAssigneeTargetLinkCriteriaModel.order;
    this.query += '&offset=' + permissionAssigneeTargetLinkCriteriaModel.offset + '&limit=' + permissionAssigneeTargetLinkCriteriaModel.limit;
  }
}
